module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "checkbox-container",
    class: [_vm.checkClasses],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleCheck.apply(null, arguments)
      }
    }
  }, [_c('input', {
    staticClass: "rounded",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.checkBoxClass
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3d4321fe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plCheckbox/plCheckbox.vue
// module id = 2358
// module chunks = 61